export default __webpack_public_path__ + "static/surgical_cta_bg-7a341b3e9acc492059324decc19abefe.png";